// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.edit-multi-select {
    border: 1px solid var(--border-color);
    padding: 0.25em;
    background-color: var(--input-bg-color);
    max-height: 5em;
    overflow-y: auto;
}`, "",{"version":3,"sources":["webpack://./components/style/EditComboField.css"],"names":[],"mappings":"AAAA;IACI,qCAAqC;IACrC,eAAe;IACf,uCAAuC;IACvC,eAAe;IACf,gBAAgB;AACpB","sourcesContent":["div.edit-multi-select {\n    border: 1px solid var(--border-color);\n    padding: 0.25em;\n    background-color: var(--input-bg-color);\n    max-height: 5em;\n    overflow-y: auto;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
